<template>
  <main-breadcrumb
    :items="items"
    showBackButton
  ></main-breadcrumb>
  <main-buttons-bar :align="'space-between'">
    <template #left>
      <custom-title>Generador de reportes</custom-title>
    </template>
  </main-buttons-bar>

  <el-row
    :gutter="20"
    class="background-container"
  >
    <el-col :span="8">
      <div class="selection-container">
        <div class="selection-label">Sección</div>
        <el-select
          v-model="seccionSeleccionada"
          placeholder="Seleccionar sección"
          size="large"
          style="width: 100%; margin-bottom: 20px"
          @change="onSeccionChange"
        >
          <el-option
            v-for="seccion in secciones"
            :key="seccion"
            :label="seccion"
            :value="seccion"
          />
        </el-select>

        <div class="selection-label">Reporte</div>
        <el-select
          v-model="reporteSeleccionado"
          placeholder="Seleccionar reporte"
          size="large"
          style="width: 100%"
          :disabled="!seccionSeleccionada"
          value-key="Codigo"
          @change="onReporteChange"
        >
          <el-option
            v-for="reporte in reportesPorSeccion"
            :key="reporte.Codigo"
            :label="reporte.Descripcion"
            :value="reporte"
          />
        </el-select>
      </div>
    </el-col>

    <el-col :span="16">
      <reports-filters
        v-if="reporteSeleccionado"
        :reporte-seleccionado="reporteSeleccionado"
      />
      <div
        v-else
        class="empty-state"
      >
        <p>Selecciona un reporte para configurar los filtros</p>
      </div>
    </el-col>
  </el-row>
</template>

<script setup>
import {
  ref,
  computed,
  onMounted,
  nextTick,
} from 'vue';
import ReporteService from '@/services/reporte_service';
import MainBreadcrumb from '@/shared/layout/main/main_breadcrum.vue';
import MainButtonsBar from '@/shared/layout/main/buttons_bar/main_buttons_bar.vue';
import CustomTitle from '@/shared/components/custom_title.vue';
import ReportsFilters from './reports_filters.vue';

const reportes = ref([]);
const seccionSeleccionada = ref(null);
const reporteSeleccionado = ref(null);

const items = [
  { label: 'Inicio', to: '/dashboard', replace: false },
  { label: 'Listado', to: null, replace: false },
];

const secciones = computed(() => {
  const seccionesUnicas = [...new Set(reportes.value.map((r) => r.Seccion))];
  return seccionesUnicas.filter(Boolean).sort();
});

const reportesPorSeccion = computed(() => {
  if (!seccionSeleccionada.value) return [];
  return reportes.value.filter((r) => r.Seccion === seccionSeleccionada.value);
});

const onSeccionChange = () => {
  reporteSeleccionado.value = null;
};

const onReporteChange = () => {
  const selectedReport = reporteSeleccionado.value;
  reporteSeleccionado.value = null;
  nextTick(() => {
    reporteSeleccionado.value = selectedReport;
  });
};

onMounted(async () => {
  try {
    const result = await ReporteService.findAll({ Activo: true });
    if (result?.data) {
      reportes.value = result.data;
    }
  } catch (error) {
    console.error('Error al cargar reportes:', error);
  }
});
</script>

<style scoped>
.background-container {
  display: flex;
  flex: 1;
  width: 100%;
  padding: 20px;
  background-color: white;
  min-height: 500px;
}

.selection-container {
  background-color: #f5f7fa;
  border: 2px solid #e4e7ed;
  border-radius: 8px;
  padding: 24px;
  height: 100%;
}

.selection-label {
  font-weight: 700;
  color: #303133;
  font-size: 14px;
  margin-bottom: 8px;
}

.empty-state {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  background-color: #f5f7fa;
  border: 2px dashed #dcdfe6;
  border-radius: 8px;
  color: #909399;
  font-size: 14px;
}

.empty-state p {
  margin: 0;
}
</style>
